// extracted by mini-css-extract-plugin
module.exports =  {"info":"info-nBG5H","label":"label-ldqPK"};